var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGuineaBissau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C14.5559 0.0107422 13.1569 0.203242 11.8261 0.56193L10.4348 16.0107L11.8261 31.4596C13.1569 31.8182 14.5559 32.0107 16 32.0107C24.8365 32.0107 32 24.8472 32 16.0107C32 7.17424 24.8365 0.0107422 16 0.0107422Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 16.0107L11.8261 31.4596C13.1569 31.8182 14.5559 32.0107 16 32.0107C24.8365 32.0107 32 24.8472 32 16.0107H10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0106C0 22.0753 3.37438 27.3516 8.34781 30.0652V1.95605C3.37438 4.66968 0 9.94593 0 16.0106Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 23.4033 5.01381 29.6236 11.8261 31.4596V0.562012C5.01381 2.39801 0 8.61839 0 16.0108Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.046 11.8369L7.08194 15.0254H10.4348L7.72244 16.9962L8.75831 20.1848L6.046 18.2141L3.33356 20.1848L4.36969 16.9962L1.65731 15.0254H5.01L6.046 11.8369Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGuineaBissau);
export default __webpack_public_path__ + "static/media/flag_guinea_bissau.c83f2077044ad0fb1c0335570d1a2683.svg";
export { ForwardRef as ReactComponent };